export enum DictionaryField {
  DCC_BANNER_TITLE = "DCC_Banner_Title",
  DCC_BANNER_SUBTITLE = "DCC_Banner_Subtitle",
  DCC_FIELDLABELS_AGE = "DCC_FieldLabels_Age",
  DCC_FIELDLABELS_APPROXIMATELYHOWMANY = "DCC_FieldLabels_ApproximatelyHowMany",
  DCC_FIELDLABELS_AVERAGEDAY = "DCC_FieldLabels_AverageDay",
  DCC_FIELDLABELS_BACK = "DCC_FieldLabels_Back",
  DCC_FIELDLABELS_CONTINUE = "DCC_FieldLabels_Continue",
  DCC_FIELDLABELS_DAILYORALMOSTDAILY = "DCC_FieldLabels_DailyOrAlmostDaily",
  DCC_FIELDLABELS_EVERYWEEK = "DCC_FieldLabels_EveryWeek",
  DCC_FIELDLABELS_FEMALE = "DCC_FieldLabels_Female",
  DCC_FIELDLABELS_GENDER = "DCC_FieldLabels_Gender",
  DCC_FIELDLABELS_HOWOFTEN = "DCC_FieldLabels_HowOften",
  DCC_FIELDLABELS_INORMALLYDRINKONTHESEDAYS = "DCC_FieldLabels_INormallyDrinkOnTheseDays",
  DCC_FIELDLABELS_LESSTHANONCEAMONTH = "DCC_FieldLabels_LessThanOnceAMonth",
  DCC_FIELDLABELS_MALE = "DCC_FieldLabels_Male",
  DCC_FIELDLABELS_NEVER = "DCC_FieldLabels_Never",
  DCC_FIELDLABELS_ONASINGLEOCCASION = "DCC_FieldLabels_OnASingleOccasion",
  DCC_FIELDLABELS_ONAVERAGE = "DCC_FieldLabels_OnAverage",
  DCC_FIELDLABELS_ONCEAMONTH = "DCC_FieldLabels_OnceAMonth",
  DCC_FIELDLABELS_ONCEAMONTHORLESS = "DCC_FieldLabels_OnceAMonthOrLess",
  DCC_FIELDLABELS_POSTCODE = "DCC_FieldLabels_Postcode",
  DCC_FIELDLABELS_POSTCODEERROR = "DCC_FieldLabels_PostcodeError",
  DCC_FIELDLABELS_POSTCODETOOLTIP = "DCC_FieldLabels_PostcodeTooltip",
  DCC_FIELDLABELS_SEXTOOLTIP = "DCC_FieldLabels_SexToolTip",
  DCC_FIELDLABELS_TWICE = "DCC_FieldLabels_Twice",
  DCC_FIELDLABELS_WEEKLY = "DCC_FieldLabels_Weekly",
  DCC_MODALS_DANGEROUSBUTTONCTA = "DCC_Modals_DangerousButtonCTA",
  DCC_MODALS_DATAUSED = "DCC_Modals_DataUsed",
  DCC_MODALS_REDUCINGTHEAMOUNTYOUDRINK = "DCC_Modals_ReducingTheAmountYouDrink",
  DCC_MODALS_UNDER18 = "DCC_Modals_Under18",
  DCC_MODALS_UNDER18BUTTONCTA = "DCC_Modals_Under18ButtonCTA",
  DCC_MODALS_YOURDRINKINGISDANGEROUS = "DCC_Modals_YourDrinkingIsDangerous",
  DCC_MYPLAN_ACHIEVEYOURGOALWITHYOURTIPS = "DCC_MyPlan_AchieveYourGoalWithYourTips",
  DCC_MYPLAN_EACHWEEK = "DCC_MyPlan_EachWeek",
  DCC_MYPLAN_SHOWMORE = "DCC_MyPlan_ShowMore",
  DCC_MYPLAN_VIEWMORETIPSANDIDEAS = "DCC_MyPlan_ViewMoreTipsAndIdeas",
  DCC_PERSONALPLAN_ACTIVEDAYS = "DCC_PersonalPlan_ActiveDays",
  DCC_PERSONALPLAN_ADD = "DCC_PersonalPlan_Add",
  DCC_PERSONALPLAN_ADDED = "DCC_PersonalPlan_Added",
  DCC_PERSONALPLAN_CREATEYOURPERSONALPLAN = "DCC_PersonalPlan_CreateYourPersonalPlan",
  DCC_PERSONALPLAN_EASYTIPS = "DCC_PersonalPlan_EasyTips",
  DCC_PERSONALPLAN_ENTERYOURDETAILS = "DCC_PersonalPlan_EnterYourDetails",
  DCC_PERSONALPLAN_HEATLH = "DCC_PersonalPlan_Health",
  DCC_PERSONALPLAN_IACCEPT = "DCC_PersonalPlan_IAccept",
  DCC_PERSONALPLAN_IACCEPTHEALTHDATA = "DCC_PersonalPlan_IAcceptHealthData",
  DCC_PERSONALPLAN_MOREINFORMATION = "DCC_PersonalPlan_MoreInformation",
  DCC_PERSONALPLAN_PRIVACYPOLICY = "DCC_PersonalPlan_PrivacyPolicy",
  DCC_PERSONALPLAN_SAVEANDVIEW = "DCC_PersonalPlan_SaveAndView",
  DCC_PERSONALPLAN_SAVEMYPLAN = "DCC_PersonalPlan_SaveMyPlan",
  DCC_PERSONALPLAN_SAVETHEACTIVITIES = "DCC_PersonalPlan_SaveTheActivities",
  DCC_PERSONALPLAN_SAVINGYOURPLANTERMS = "DCC_PersonalPlan_SavingYourPlanTerms",
  DCC_PERSONALPLAN_SELECTACTIVITIES = "DCC_PersonalPlan_SelectActivities",
  DCC_PERSONALPLAN_WELLSENDYOUANEMAIL = "DCC_PersonalPlan_WellSendYouAnEmail",
  DCC_PERSONALPLAN_SKIPTOMYPLAN = "DCC_PersonalPlan_SkipToMyPlan",
  DCC_PERSONALPLAN_CONFIDENTIALSUPPORT = "DCC_PersonalPlan_ConfidentialSupport",
  DCC_PERSONALPLAN_DRINKCHATLINE = "DCC_PersonalPlan_DrinkChatLine",
  DCC_PLANRESULTS_DRINKFREEDAYSEACHWEEK = "DCC_PlanResults_DrinkFreeDayEachWeek",
  DCC_PLANRESULTS_EACHWEEKTHISISEQUALTO = "DCC_PlanResults_EachWeekThisIsEqualTo",
  DCC_PLANRESULTS_EACHWEEKTHISWILLRESULTIN = "DCC_PlanResults_EachWeekThisWillResultIn",
  DCC_PLANRESULTS_OFTHEPOPULATION = "DCC_PlanResults_OfThePopulation",
  DCC_PLANRESULTS_REDUCINGYOURCONSUMPTION = "DCC_PlanResults_ReducingYourConsumption",
  DCC_PLANRESULTS_YOUHAVEPLANNEDTODRINKNOMORETHAN = "DCC_PlanResults_YouHavePlannedToDrinkNoMoreThan",
  DCC_PLANRESULTS_YOUHAVEPLANNEDTOHAVE = "DCC_PlanResults_DCC_PlanResults_YouHavePlannedToHave",
  DCC_RESULTS_ACTIVITIESTOTRYONDRINKFREEDAYS = "DCC_Results_ActivitiesToTryOnDrinkFreeDays",
  DCC_RESULTS_BINGEDRINKWARNING = "DCC_Results_BingeDrinkWarning",
  DCC_RESULTS_LOWRISKBINGEWARNING = "DCC_Results_LowRiskBingeWarning",
  DCC_RESULTS_CREATEYOUROWNACTIONPLAN = "DCC_Results_CreateYourOwnActionPlan",
  DCC_RESULTS_EACHWEEKYOUARECONSUMING = "DCC_Results_EachWeekYouAreConsuming",
  DCC_RESULTS_EACHWEEKYOURTOTALDAILYUNITSARE = "DCC_Results_EachWeekYourTotalDailyUnitsAre",
  DCC_RESULTS_EASYWAYSTOGETACTIVE = "DCC_Results_EasyWaysToGetActive",
  DCC_RESULTS_GETPRACTICALTIPS = "DCC_Results_GetPracticalTips",
  DCC_RESULTS_HEALTHBENEFITSTOMOTIVATEYOU = "DCC_Results_HealthBenefitsToMotivateYou",
  DCC_RESULTS_READYTOSTART = "DCC_Results_ImReadyToStart",
  DCC_RESULTS_LETSGETSTARTED = "DCC_Results_LetsGetStarted",
  DCC_RESULTS_LOOKINGFORADVICEFORSOMEONEELSE = "DCC_Results_LookingForAdviceForSomeoneElse",
  DCC_RESULTS_NOWYOUVESETYOURGOAL = "DCC_Results_NowYouveSetYourGoal",
  DCC_RESULTS_OFMENDRINKLESSTHANYOU = "DCC_Results_OfMenDrinkLessThanYou",
  DCC_RESULTS_OFWOMENDRINKLESSTHANYOU = "DCC_Results_OfWomenDrinkLessThanYou",
  DCC_RESULTS_PICKSUPPORTTHATSRIGHTFORYOU = "DCC_Results_PickSupportThatsRightForYou",
  DCC_RESULTS_POPULATIONWHODONOTDRINK = "DCC_Results_PopulationWhoDoNotDrink",
  DCC_RESULTS_SELECTMOREDRINKFREEDAYS = "DCC_Results_SelectMoreDrinkFreeDays",
  DCC_RESULTS_SETYOURSELFAGOAL = "DCC_Results_SetYourselfAGoal",
  DCC_RESULTS_SHOWMEHOW = "DCC_Results_ShowMeHow",
  DCC_RESULTS_SHOWMETIPS = "DCC_Results_ShowMeTips",
  DCC_RESULTS_SIMPLETIPS = "DCC_Results_SimpleTips",
  DCC_RESULTS_TAKINGMOREDRINKFREEDAYS = "DCC_Results_TakingMoreDrinkFreeDays",
  DCC_RESULTS_THERESLOTSOFWAYS = "DCC_Results_TheresLotsOfWays",
  DCC_RESULTS_VIEWINFORMATIONABOUTTHEHEALTHBENEFITS = "DCC_Results_ViewInformationAboutTheHealthBenefits",
  DCC_RESULTS_WANTANEASYWAY = "DCC_Results_WantAnEasyWay",
  DCC_RESULTS_WANTMOREIDEAS = "DCC_Results_WantMoreIdeas",
  DCC_RESULTS_WANTSUPPORTTOKEEP = "DCC_Results_WantSupportToKeep",
  DCC_RESULTS_WANTSUPPORTTOREDUCE = "DCC_Results_WantSupportToReduce",
  DCC_RESULTS_YOU = "DCC_Results_You",
  DCC_RESULTS_YOUDONTDRINK = "DCC_Results_YouDontDrink",
  DCC_RESULTS_YOUNOW = "DCC_Results_YouNow",
  DCC_RESULTS_YOURDRINKINGISDANGEROUS = "DCC_Results_YourDrinkingIsDangerous",
  DCC_RESULTS_YOURDRINKINGISPUTTINGYOURHEALTHATRISK = "DCC_Results_YourDrinkingIsPuttingYourHealthAtRisk",
  DCC_RESULTS_YOURDRINKINGRISK = "DCC_Results_YourDrinkingRisk",
  DCC_RESULTS_YOUREDRINKINGWITHINTHELOWRISKGUIDELINES = "DCC_Results_YoureDrinkingWithinTheLowRiskGuidelines",
  DCC_RESULTS_LOWBINGEDRINKER = "DCC_Results_LowBingeDrinker",
  DCC_RESULTS_YOURETAKINGDRINKFREEDAYS = "DCC_Results_YoureTakingDrinkFreeDays",
  DCC_RESULTS_YOURGOAL = "DCC_Results_YourGoal",
  DCC_RESULTS_YOURRESULTS = "DCC_Results_YourResults",
  DCC_RESULTS_YOURRESULTSSHOWTHATYOUDONTDRINK = "DCC_Results_YourResultsShowThatYouDontDrink",
  DCC_WELCOME_BUTTONTEXT = "DCC_Welcome_ButtonText",
  DCC_WELCOME_TEXT_2 = "DCC_Welcome_Text2",
  DCC_WELCOME_TEXT_1 = "DCC_Welcome_Text1",
  DCC_WELCOME_TITLE = "DCC_Welcome_Title",
  TOOLS_GENERAL_BACK = "Tools_General_Back",
  TOOLS_GENERAL_BEER = "Tools_General_Beer",
  TOOLS_GENERAL_BEERCIDER = "Tools_General_BeerCider",
  TOOLS_GENERAL_BOTTLE330 = "Tools_General_Bottle330",
  TOOLS_GENERAL_CALORIES = "Tools_General_Calories",
  TOOLS_GENERAL_CHEESEBURGERS = "Tools_General_Cheeseburgers",
  TOOLS_GENERAL_CONTINUE = "Tools_General_Continue",
  TOOLS_GENERAL_DRINKS = "Tools_General_Drinks",
  TOOLS_GENERAL_EMAIL = "Tools_General_Email",
  TOOLS_GENERAL_FEMALE = "Tools_General_Female",
  TOOLS_GENERAL_FIRSTNAME = "Tools_General_FirstName",
  TOOLS_GENERAL_GENDER = "Tools_General_Gender",
  TOOLS_GENERAL_HIGHRISK = "Tools_General_HighRisk",
  TOOLS_GENERAL_INCREASINGRISK = "Tools_General_IncreasingRisk",
  TOOLS_GENERAL_LASTNAME = "Tools_General_LastName",
  TOOLS_GENERAL_LOWRISK = "Tools_General_LowRisk",
  TOOLS_GENERAL_MALE = "Tools_General_Male",
  TOOLS_GENERAL_MEDIUMGLASS = "Tools_General_MediumGlass",
  TOOLS_GENERAL_PINT = "Tools_General_Pint",
  TOOLS_GENERAL_POSTCODE = "Tools_General_Postcode",
  TOOLS_GENERAL_READLESS = "Tools_General_ReadLess",
  TOOLS_GENERAL_READMORE = "Tools_General_ReadMore",
  TOOLS_GENERAL_SINGLEMEASURE = "Tools_General_SingleMeasure",
  TOOLS_GENERAL_SPIRIT = "Tools_General_Spirit",
  TOOLS_GENERAL_UNITS = "Tools_General_Units",
  TOOLS_GENERAL_WINE = "Tools_General_Wine",
  TOOLS_GENERAL_SINGLESPIRIT25 = "Tools_General_SingleSpirit25",
  TOOLS_GENERAL_VALIDPOSTCODE = "Tools_General_ValidPostcode",
  TOOLS_GENERAL_POSTCODEHOVERTEXT1 = "Scratchcard_Postcode_HoverText1",
  TOOLS_GENERAL_POSTCODEHOVERTEXT2 = "Scratchcard_Postcode_HoverText2",
  TOOLS_GENERAL_PRIVACYPOLICY = "Tools_General_PrivacyPolicy",
  TOOLS_GENERAL_TERMSANDCONDITIONS = "Tools_General_TermsAndConditions"
}

export const dictionaryFieldMap = Object.entries(DictionaryField).reduce<
  string[]
>((agg, curr) => {
  const value = curr[1];
  agg.push(value);
  return agg;
}, []);
